import { Pipe, PipeTransform } from '@angular/core';
import { EntityDisplay, EntitySlugs } from '@app/shell/menu/menu.component';
import { BackgroundColor } from '@app/components/menuItem/menuItem.component';
import { isMenuItemMatchingCurrentRoute } from '@shared/pipes/menuItem/menuItem.pipe.utils';

@Pipe({ name: 'menuItemBackgroundColor' })
export class MenuItemBackgroundColorPipe implements PipeTransform {
  public transform(entity: EntityDisplay | null, routeSlugs: EntitySlugs | null): BackgroundColor {
    if (entity && routeSlugs) {
      if (isMenuItemMatchingCurrentRoute(entity, routeSlugs)) {
        return BackgroundColor.black;
      } else {
        return entity.menuItem.backgroundColor;
      }
    }

    return BackgroundColor.gray700;
  }
}
